import logoHWthite from "../assets/logo-Origo-h-w.svg";
import logoBGWhite from "../assets/logo-Origo-bg.svg";
import logoIsoWhite from "../assets/logo-Origo-Iso-White.svg";
import logoMeWhite from "../assets/logo-me-white.svg";
import logoVisa from "../assets/visa-logo.svg";

import BubblesPublic from "../assets/bubbles-public.svg";
import FooterBg from "../assets/bg-footer.svg";

import IconCollege from "../assets/menu-colleges-icon-w.svg";
import IconCourse from "../assets/menu-courses-icon-w.svg";
import IconProfile from "../assets/menu-profile-icon-w.svg";
import IconProposal from "../assets/menu-proposal-icon-w.svg";

import IconCollegeR from "../assets/menu-colleges-icon.svg";
import IconProfileR from "../assets/menu-profile-icon.svg";
import IconCourseR from "../assets/menu-courses-icon.svg";
import IconProposalNotification from "../assets/icon-proposal-notification.svg";
import IconAlert from "../assets/icon-alert-popup.svg";
import IconSuccess from "../assets/icon-success.svg";
import IconSearch from "../assets/search-icon.svg";

import IconEdit from "../assets/Icon-Edit.svg";

import IconRemove from "../assets/Item-remove-icon.svg";
import IconCloseModal from "../assets/close-modal-icon.svg";
import IconDelete from "../assets/Icon-Remove.svg";

import IconFavDisable from "../assets/icon-favorite-disable.svg";
import IconFavActive from "../assets/icon-favorite-active.svg";

import IconInsurance from "../assets/icon-insurance.svg";
import IconVisa from "../assets/icon-visa.svg";
import IconPayment from "../assets/icon-payment.svg";
import IconChange from "../assets/icon-change.svg";
import IconComment from "../assets/icon-comment.svg";

import OSHC from "../assets/insurance-OSHC.jpg";
import CBHS from "../assets/insurance-CBHS.jpg";
import nib from "../assets/insurance-nib.jpg";
import allianz from "../assets/insurance-allianz.jpg";
import Medibank from "../assets/insurance-medibank.jpg";
import Bupa from "../assets/insurance-bupa.jpg";

import Seb from "../assets/seb.svg";
// eslint-disable-next-line
export default {
  Seb,
  BubblesPublic,
  FooterBg,

  logoHWthite,
  logoBGWhite,
  logoIsoWhite,
  logoMeWhite,
  logoVisa,

  IconCollege,
  IconCourse,
  IconProfile,
  IconProposal,
  IconComment,
  IconProposalNotification,

  IconCollegeR,
  IconProfileR,
  IconCourseR,
  IconAlert,
  IconSuccess,

  IconSearch,
  IconRemove,
  IconCloseModal,
  IconDelete,
  IconEdit,

  IconFavDisable,
  IconFavActive,

  IconInsurance,
  IconVisa,
  IconPayment,

  IconChange,

  OSHC,
  CBHS,
  nib,
  allianz,
  Medibank,
  Bupa,
};
